import { createBreakpointHook } from '@restart/hooks/useBreakpoint';

import mapValues from 'lodash/mapValues';
const breakpointValuesPx = require('./useResponsive-breakpointValuesPx.module.scss');
const breakpointValues = mapValues(breakpointValuesPx, parseFloat);
const useResponsive = createBreakpointHook(breakpointValues);
export default useResponsive;